module.exports = __webpack_public_path__ + "static/media/Driver Trainings IDTR.ca68233a.csv";